import React, { useCallback, useEffect } from "react";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// css
import classes from "./UserSidepanel.module.css";
// Jds
import { ActionButton, Container, Icon, Text, Tooltip } from "@jds/core";
import useApiHttp from "../../../hooks/use-http";
import { setSidebarDetails } from "../../../store/state-slices/eventDetails";
import { Skeleton } from "@mui/material";

export default function UserSidepanel(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id: eventId } = useParams();
  const profileDetailsRedux = useSelector(
    (state) => state.profileDetails.profileDetails
  );
  const { eventDetails } = useSelector((state) => state.eventDetails);
  const { sendRequest: getEventDetails, isLoading } = useApiHttp();
  const loginDetails = useSelector(state => state.auth.loginDetails)
  const isJitoUser = loginDetails?.userType === 'JITO'
  const handleNavigateHome = useCallback(() => {
    if (!isJitoUser) {
      navigate("/home");
    } else {
      navigate(-1)
    }
  }, []);

  const isAdmin = eventDetails?.userRole == "ADMIN";
  const isPhotographer = eventDetails?.userRole == "PHOTOGRAPHER";

  return (
    <Container
      width="264px"
      style={{
        boxShadow: "var(--box-shadow-card)",
        padding: "32px 24px",
        height: "calc(100vh - 80.95px)",
        position: "sticky",
        top: "72px",
        marginTop: "72px",
      }}
      overflow="auto"
      direction="column"
      gap={16}
    >
      <div onClick={handleNavigateHome} style={{ cursor: "pointer" }}>
        <Container
          style={{ padding: "20px 0px" }}
          fullWidth
          direction="row"
          verticalAlign="center"
        >
          <Icon ic={"IcBack"} />
          <Text text="Home" appearance="body-m-bold" maxLines={2} />

          {/* {isLoading ? (
          <Skeleton variant="text" sx={{ fontSize: "1rem", width: "100%" }} />
        ) : (
          <Text text="Home" appearance="body-m-bold" maxLines={2} />
        )} */}
        </Container>
      </div>
      <ul className={classes["nav__list"]}>
        <li className={classes["nav__item"]}>
          <NavLink
            className={classes["nav__link"]}
            to={`/userdetail/edit-profile`}
            style={({ isActive }) => {
              return {
                backgroundColor: isActive
                  ? "var(--color-primary-20)"
                  : "",
              };
            }}
          >
            <Icon ic={"IcProfile"} />
            <Text
              text={`${profileDetailsRedux?.userType === 'SCHOOL' ? 'Edit' : 'Edit'} Profile`}
              color="primary_grey_80"
            />
          </NavLink>
        </li>
        {/* <li>
          <NavLink
            className={classes["nav__link"]}
            to={`/userdetail/membership`}
            style={({ isActive }) => {
              return {
                backgroundColor: isActive
                  ? "var(--color-primary-20)"
                  : "",
              };
            }}
          >
            <Icon ic={"IcCard"} />
            <Text
              text="Membership"
              appearance=""
              color="primary_grey_80"
            />
          </NavLink>
        </li> */}
      </ul>
    </Container>
  );
}
